import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function EventsUsersRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EventsUsers', {
		url: '/admin/events/users',
		controllerAs: 'vm',
		controller: EventsUsersCtrl,
		templateUrl: '/ng/hub/Events/Users/EventsUsersCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Events/Users/EventsUsersCtrl.css'),
			$title: () => 'Users Online Now',
			users: ApiResourcify.endpoint('/metrics/users'),
		},
	});
}

export class EventsUsersCtrl {
	constructor(Api, users) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.users = users;
	}

	async showDetails(user) {
		this.users.forEach(user => (user.selected = false));
		user.selected = true;
		this.details = user;
		this.events = [];
		const criteria = { user_id: user.id };
		this.events = await this.Api.get('/metrics/events/search', criteria);
	}
}
